/**
 * One page of a list the backend returns whole. A page past the end (e.g. after rows were removed)
 * shows the last page.
 */
export const paginate = <T>(items: T[], page: number, size: number) => {
  const totalPages = Math.max(1, Math.ceil(items.length / size));
  const currentPage = Math.min(Math.max(1, page), totalPages);
  const start = (currentPage - 1) * size;
  return {
    pageItems: items.slice(start, start + size),
    totalPages,
    currentPage,
  };
};
